var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSmallGreyArrowUpright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0021 17.998C16.7369 17.998 16.4826 17.8926 16.295 17.7051C16.1075 17.5176 16.0021 17.2632 16.0021 16.998V9.40798L7.71214 17.708C7.52383 17.8963 7.26844 18.0021 7.00214 18.0021C6.73584 18.0021 6.48044 17.8963 6.29214 17.708C6.10383 17.5197 5.99805 17.2643 5.99805 16.998C5.99805 16.7317 6.10383 16.4763 6.29214 16.288L14.5921 7.99798H7.00214C6.73692 7.99798 6.48257 7.89263 6.29503 7.70509C6.1075 7.51756 6.00214 7.2632 6.00214 6.99798C6.00214 6.73277 6.1075 6.47841 6.29503 6.29088C6.48257 6.10334 6.73692 5.99798 7.00214 5.99798H17.0021C17.1328 5.99956 17.2619 6.02674 17.3821 6.07798C17.6265 6.17946 17.8207 6.37364 17.9221 6.61798C17.9734 6.73821 18.0006 6.86731 18.0021 6.99798V16.998C18.0021 17.2632 17.8968 17.5176 17.7092 17.7051C17.5217 17.8926 17.2674 17.998 17.0021 17.998Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallGreyArrowUpright);
export default __webpack_public_path__ + "static/media/Icon-Small-Grey-Arrow-Up right.6343fdcf3687a009e7e936b0f18b7946.svg";
export { ForwardRef as ReactComponent };